"use client"

import * as React from "react"
import { HexColorPicker, HexColorInput } from "react-colorful"

import { Button } from "./button"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"
import { cn } from "../../lib/utils"

interface ColorPickerProps {
  id?: string
  value: string
  onChange: (color: string) => void
  className?: string
}

export function ColorPicker({ id, value, onChange, className }: ColorPickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant="outline"
          className={cn("h-9 w-16 p-0 rounded", className)}
          style={{ backgroundColor: value }}
        >
          <span className="sr-only">Selecionar cor</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <HexColorPicker color={value} onChange={onChange} className="!w-[220px]" />
        <div className="p-3 border-t">
          <HexColorInput
            color={value}
            onChange={onChange}
            prefixed
            className="flex h-8 w-full rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          />
        </div>
      </PopoverContent>
    </Popover>
  )
}
